<template>
  <b-modal
    :title="$t('GERAL.ESCOLHA_ALUNO')"
    header-bg-variant="light"
    ref="modal-senha"
    size="md"
    hide-footer
    @hidden="fecharModal()"
  >
    <b-card-text>
      <p class="text-center">
        <b>{{ $t("GERAL.TEXTO_SELECIONAR_ALUNO") }}</b>
      </p>
      <b-container class="bv-example-row mt-3">
        <b-row class="justify-content-center">
          <b-col sm="6" xs="12" v-for="aluno in alunos" :key="aluno.index">
            <div class="escolher-aluno-card" @click="selecionarAluno(aluno)">
              <div class="d-flex justify-content-center">
                <b-avatar src="" size="6rem"></b-avatar>
              </div>
              <div class="escolher-aluno-nome">{{ aluno.nome }}</div>
              <div class="escolher-aluno-nome mt-1">
                {{ $t("ACADEMICO.MATRICULA") }} {{ aluno.matriculaCodigo }}
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card-text>
  </b-modal>
</template>
<script>
import mensagem from "@/common/utils/mensagem";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import AutenticacaoService from "@/common/services/autenticacao/autenticacao.service";
import {
  BUSCAR_ALUNOS_VINCULADOS,
  SALVAR_ALUNO_SELECIONADO,
  SALVAR_TOKEN_ALUNO_SELECIONADO,
} from "@/store/autenticacao.module";

export default {
  name: "ModalEscolherAluno",
  props: {
    mostrarModal: { type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        email: null,
      },
      alunos: [],
    };
  },
  watch: {
    mostrarModal(valor) {
      if (valor) {
        this.buscarAlunosVinculados();
        this.$refs["modal-senha"].show();
      } else this.$refs["modal-senha"].hide();
    },
  },
  methods: {
    fecharModal() {
      this.$emit("fecharModal");
    },
    buscarAlunosVinculados() {
      this.$store.dispatch(BUSCAR_ALUNOS_VINCULADOS).then((data) => {
        this.alunos = data;
      });
    },
    selecionarAluno(aluno) {
      this.$store.dispatch(START_LOADING);

      AutenticacaoService.logarAlunoSelecionado(aluno)
        .then((data) => {
          this.$store.dispatch(SALVAR_ALUNO_SELECIONADO, aluno);
          this.$store.dispatch(
            SALVAR_TOKEN_ALUNO_SELECIONADO,
            data.data.accessToken
          );

          this.$emit("atualizar");
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>

<style>
.escolher-aluno-card {
  padding: 15px;
  background: #f1f1f1;
  border-radius: 10px;
  flex-direction: column;
  margin-bottom: 20px;
  cursor: pointer;
}
.escolher-aluno-nome {
  text-align: center;
  font-weight: 700;
  margin-top: 15px;
}
</style>
